import { useEffect, useState } from "react";

// Detects the on-screen keyboard on mobile (§B8 / 03 §4): when it opens, the visualViewport
// shrinks well below the layout viewport. On the cramped analysis steps (375x667) the rail +
// title + textarea + counter + submit + keyboard do not all fit, so the rail is hidden while
// the keyboard is up. Client-only, degrades to "never open" where visualViewport is absent.
const KEYBOARD_RATIO = 0.8;

export const useKeyboardOpen = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const vv = typeof window !== "undefined" ? window.visualViewport : null;
    if (!vv) return undefined;

    const check = () => {
      // The keyboard is considered up when the visual viewport is meaningfully shorter than
      // the window's inner height.
      setOpen(vv.height < window.innerHeight * KEYBOARD_RATIO);
    };
    check();
    vv.addEventListener("resize", check);
    return () => vv.removeEventListener("resize", check);
  }, []);

  return open;
};
